<template>
  <page title="Gebruik de Google Chrome Browser" :back="false" :panel="false">
		<f7-card>
      <f7-card-header><b>Om deze app te kunnen gebruiken heb je de Google Chrome browser nodig!</b></f7-card-header>
      <f7-card-content>
         <b>Volg onderstaande instructies:</b><br>
        Download en installeer de Google Chrome browser op je telefoon via deze link:<br>
        <a href="https://play.google.com/store/apps/details?id=com.android.chrome&pcampaignid=web_share" target="_blank" class="link external">Download Google Chrome</a>

        <br><br>
        Open <b>{{$Config.apps[$Config.app.currentApp].appversionURL}}</b> in de <b>Google Chrome Browser</b> en klik bovenaan op de installeren knop om de app op je telefoon te installeren.
      </f7-card-content>
    </f7-card>
    
    <f7-card style="margin-top: 40px;">
      <f7-card-header><b>To use this app you need the Google Chrome browser!</b></f7-card-header>
      <f7-card-content>
        <b>Follow the instructions below:</b><br>
        Download and install the Google Chrome browser on your phone via this link:<br>
        <a href="https://play.google.com/store/apps/details?id=com.android.chrome&pcampaignid=web_share" target="_blank" class="link external">Download Google Chrome</a>

        <br><br>
        Open <b>{{$Config.apps[$Config.app.currentApp].appversionURL}}</b> in the <b>Google Chrome Browser</b> and click the install button at the top to install the app on your phone.
      </f7-card-content>
    </f7-card>
	</page>
</template>

<script>
import Page from '../components/smart/page.vue';

export default {
  components: {
    'page': Page,
  },
}
</script>
